import {isAuthenticated} from "./isAuthenticated";

const DefaultGetConfig = (authObj) => {
    let isAuthToken = isAuthenticated(authObj);

    if (isAuthToken) {
        return {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authObj.authToken}`,
            },
            params: {
                'origen': 'affinity'
            }
        }
    } else {
        return {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idAfinidad: authObj.idAfinidad,
                'origen': 'affinity'
            }
        }
    }
};

export default DefaultGetConfig;